<template>
  <v-card
    :outlined="outlined"
    :color="color"
    :flat="flat"
    class="hour-input"
    :class="{
      'hour-input-no-actions': loading,
      [roundClass]: true
    }"
  >
    <div
      v-if="loading"
      class="text-center pa-2 mt-2"
    >
      <v-skeleton-loader v-for="n in 10" :key="n" type="image" width="100%" height="56" class="mb-2"></v-skeleton-loader>
    </div>
    <v-list v-if="hours && hours.length > 0 && !loading" :color="color" :flat="flat">
      <v-list-item-group
        v-model="active"
      >
        <v-sheet
          outlined
          v-for="(item, i) in hours"
          :disabled="showBookedSlots && item.booked"
          class="ma-2"
          :class="{
            [roundClass]: true,
            'text-disabled': showBookedSlots && item.booked,
            'hour-wrapper': !item.booked
          }"
          :key="i">
          <v-list-item
            :value="item"
            color="primary"
            class="text-center"
            :disabled="showBookedSlots && item.booked"
          >
            <v-list-item-content>
              <v-list-item-title :class="{
                'text-decoration-line-through text-disabled': showBookedSlots && item.booked
              }">
                {{ item.time | timeNotation }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="showGroupInfo">
                <small>{{ $trans('free_spots') }}: {{ item.max - item.used}}</small>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="bookingButton" v-show="activeHour && item.time === activeHour.time">
              <v-btn
                color="primary"
                depressed
                @click="$emit('book', activeHour)"
              >
                {{ bookNowLabel }}
              </v-btn>
            </v-list-item-action>
            <v-list-item-icon v-if="!bookingButton" v-show="activeHour && item.time === activeHour.time">
              <v-icon v-text="'$check'" />
            </v-list-item-icon>
          </v-list-item>
        </v-sheet>
      </v-list-item-group>
    </v-list>
    <div
      v-else-if="!loading"
      class="hour-input__no-data"
    >
      <v-container class="color-1-base">
        <v-row>
          <v-col class="text-center font-weight-medium">
            <span v-if="showLocationError">{{ $trans('select_location_calendar_warning') }}</span>
            <span v-else>{{ $trans('no_free_hours') }}</span>
          </v-col>
        </v-row>
        <v-row v-if="firstAvailableDate">
          <v-col class="text-center">
            {{ $trans('first_available_date')}}<br><span class="font-weight-medium">{{ firstAvailableDate | moment('dddd D MMMM') }}</span>
          </v-col>
        </v-row>
        <v-row v-if="firstAvailableDate">
          <v-col class="d-flex justify-center">
            <v-btn
              color="primary"
              depressed
              @click="$emit('date', firstAvailableDate)"
            >
              {{ $trans('select_date') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>

<script>
import mixins from 'vue-typed-mixins'
import DraftElement from '@/calendesk/sections/section/mixins/DraftElement'

export default mixins(DraftElement).extend({
  name: 'BookingTimePicker',
  model: {
    prop: 'activeHour',
    event: 'selectedHour'
  },
  props: {
    hours: {
      type: Array,
      required: true
    },
    activeHour: {
      type: Object
    },
    firstAvailableDate: {
      type: String
    },
    roundClass: {
      type: String,
      default: 'rounded'
    },
    loading: {
      type: Boolean,
      default: false
    },
    showGroupInfo: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    bookNowLabel: {
      type: String,
      default: null
    },
    bookingButton: {
      type: Boolean,
      default: false
    },
    showLocationError: {
      type: Boolean,
      default: false
    },
    showBookedSlots: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: null
    }
  },
  watch: {
    active () {
      this.$emit('selectedHour', this.active)
    },
    activeHour () {
      this.active = this.activeHour
    },
    hours () {
      this.active = null
    }
  },
  mounted () {
    this.active = this.activeHour
  }
})
</script>

<style lang="scss" scoped>
.hour-input {
  height: 100%;
  width: 100%;
  overflow: auto;
}

.hour-input-no-actions {
  pointer-events: none;
}

.v-list-item {
  height: 56px;
}

.hour-wrapper {
  border-color: var(--v-primary-base);
}

.hour-input__no-data {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
